import { defineMessages } from 'react-intl';

export const releasePhaseMessages = defineMessages({
  preview: {
    defaultMessage: 'Preview',
    description:
      'Chip label indicating a feature or an app is in preview release phase',
    id: '92og/kC9Mmwxmmg0',
  },
  new: {
    defaultMessage: 'New',
    description: 'Chip label indicating a feature is newly released',
    id: '+Jc1Pz2t25AcHil0',
  },
  deprecated: {
    defaultMessage: 'Deprecated',
    description: 'Chip label indicating a feature is deprecated',
    id: 'VwnLYpww5VUT3cdu',
  },
  earlyAccess: {
    defaultMessage: 'Early Access',
    description:
      'Chip label indicating a feature or an app is in early access release phase',
    id: '8bfwTDfvbh8A1Rkz',
  },
});
